module.exports = "../../static/fonts/SharpSansDispNo1-Bold.ec59f96.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SharpSansDispNo1-Bold.woff
// module id = 1327
// module chunks = 0